import {
  Box,
  Button,
  Card,
  Paper,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  Tabs,
} from "@mui/material";
import styles from "./style.module.css";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import DownloadIcon from "@mui/icons-material/Download";
import { useEffect, useState } from "react";
import * as XLSX from "xlsx";
import axios from "axios";
import PropTypes from "prop-types";
import Loading from "../../components/Loading";

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

CustomTabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const VamosVencerJuntos = () => {
  const [page, setPage] = useState(0);
  const [pageFila, setPageFila] = useState(0);
  const [pageConfirmados, setPageConfirmados] = useState(0);
  const [pageNaoConfirmados, setPageNaoConfirmados] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [rowsPerPageFila, setRowsPerPageFila] = useState(5);
  const [rowsPerPageConfirmados, setRowsPerPageConfirmados] = useState(5);
  const [rowsPerPageNaoConfirmados, setRowsPerPageNaoConfirmados] = useState(5);
  const [cadastro, setCadastro] = useState();
  const [qtdCadastro, setQtdCadastro] = useState();
  const [loading, setLoading] = useState(false);
  const [value, setValue] = useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleResponse = async () => {
    setLoading(true);
    const responseCadastros = await axios.get(
      "https://api.arquivosimples.com.br/cadastro/RLwZsyt1ckuPwSsuI40o2fJPxdAbTuuy"
    );
    const responseQtd = await axios.get(
      "https://api.arquivosimples.com.br/cadastro/qtd-cadastros"
    );
    setCadastro(responseCadastros.data);
    setQtdCadastro(responseQtd.data);
    setLoading(false);
  };

  useEffect(() => {
    const fetchHandle = async () => {
      await handleResponse();
    };
    fetchHandle();
  }, []);

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  const handleChangePageFila = (_, newPage) => {
    setPageFila(newPage);
  };

  const handleChangePageConfirmados = (_, newPage) => {
    setPageConfirmados(newPage);
  };

  const handleChangePageNaoConfirmados = (_, newPage) => {
    setPageNaoConfirmados(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeRowsPerPageFila = (event) => {
    setRowsPerPageFila(parseInt(event.target.value, 10));
    setPageFila(0);
  };

  const handleChangeRowsPerPageConfirmados = (event) => {
    setRowsPerPageConfirmados(parseInt(event.target.value, 10));
    setPageConfirmados(0);
  };

  const handleChangeRowsPerPageNaoConfirmados = (event) => {
    setRowsPerPageNaoConfirmados(parseInt(event.target.value, 10));
    setPageNaoConfirmados(0);
  };

  function handleCorrigeDate(timestamp) {
    const data = new Date(timestamp);
    return data.toLocaleString().replace(",", "").toString();
  }

  const handleDownload = () => {
    const rows = cadastro?.cadastros.map((cadastro, index) => ({
      nome: cadastro.nome,
      whatsapp: cadastro.whatsapp,
      email: cadastro.email,
      empresa: cadastro.empresa,
      qtd_acompanhante: cadastro.qtdAcompanhante,
      acompanhante1: cadastro.acompanhante1 ?? "-",
      acompanhante2: cadastro.acompanhante2 ?? "-",
      acompanhante3: cadastro.acompanhante3 ?? "-",
      dtCadastro: cadastro.dtCadastro
        ? handleCorrigeDate(cadastro.dtCadastro)
        : "-",
      total: index === 0 ? qtdCadastro?.qtdTotal : "",
    }));
    const rowsFila = cadastro?.cadastrosFila.map((cadastro, index) => ({
      nome: cadastro.nome,
      whatsapp: cadastro.whatsapp,
      email: cadastro.email,
      empresa: cadastro.empresa,
      qtd_acompanhante: cadastro.qtdAcompanhante,
      acompanhante1: cadastro.acompanhante1 ?? "-",
      acompanhante2: cadastro.acompanhante2 ?? "-",
      acompanhante3: cadastro.acompanhante3 ?? "-",
      dtCadastro: cadastro.dtCadastro
        ? handleCorrigeDate(cadastro.dtCadastro)
        : "-",
      total: index === 0 ? qtdCadastro?.qtdFilaTotal : "",
    }));
    const rowsConfirmados = cadastro?.cadastrosConfirmados.map(
      (cadastro, index) => ({
        nome: cadastro.nome,
        whatsapp: cadastro.whatsapp,
        email: cadastro.email,
        empresa: cadastro.empresa,
        qtd_acompanhante: cadastro.qtdAcompanhante,
        acompanhante1: cadastro.acompanhante1 ?? "-",
        acompanhante2: cadastro.acompanhante2 ?? "-",
        acompanhante3: cadastro.acompanhante3 ?? "-",
        dtCadastro: cadastro.dtCadastro
          ? handleCorrigeDate(cadastro.dtCadastro)
          : "-",
        total: index === 0 ? qtdCadastro?.qtdConfirmadosTotal : "",
      })
    );
    const rowsNaoConfirmados = cadastro?.cadastrosNaoConfirmados.map(
      (cadastro, index) => ({
        nome: cadastro.nome,
        whatsapp: cadastro.whatsapp,
        email: cadastro.email,
        empresa: cadastro.empresa,
        qtd_acompanhante: cadastro.qtdAcompanhante,
        acompanhante1: cadastro.acompanhante1 ?? "-",
        acompanhante2: cadastro.acompanhante2 ?? "-",
        acompanhante3: cadastro.acompanhante3 ?? "-",
        dtCadastro: cadastro.dtCadastro
          ? handleCorrigeDate(cadastro.dtCadastro)
          : "-",
        total: index === 0 ? qtdCadastro?.qtdNaoConfirmadosTotal : "",
      })
    );
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(rows);
    const worksheetFila = XLSX.utils.json_to_sheet(rowsFila);
    const worksheetConfirmados = XLSX.utils.json_to_sheet(rowsConfirmados);
    const worksheetNaoConfirmados =
      XLSX.utils.json_to_sheet(rowsNaoConfirmados);

    XLSX.utils.book_append_sheet(workbook, worksheet, "Cadastrados");
    XLSX.utils.book_append_sheet(workbook, worksheetFila, "Fila de Espera");
    XLSX.utils.book_append_sheet(workbook, worksheetConfirmados, "Confirmados");
    XLSX.utils.book_append_sheet(
      workbook,
      worksheetNaoConfirmados,
      "Não Confirmados"
    );

    XLSX.writeFile(workbook, "cadastros_vamos_vencer_juntos.xlsx", {
      compression: true,
    });
  };

  const emptyRows =
    page > 0
      ? Math.max(0, (1 + page) * rowsPerPage - cadastro?.cadastros.length)
      : 0;
  const emptyRowsFila =
    pageFila > 0
      ? Math.max(
          0,
          (1 + pageFila) * rowsPerPageFila - cadastro?.cadastrosFila.length
        )
      : 0;
  const emptyRowsConfirmados =
    pageConfirmados > 0
      ? Math.max(
          0,
          (1 + pageConfirmados) * rowsPerPageConfirmados -
            cadastro?.cadastrosConfirmados.length
        )
      : 0;
  const emptyRowsNaoConfirmados =
    pageNaoConfirmados > 0
      ? Math.max(
          0,
          (1 + pageNaoConfirmados) * rowsPerPageNaoConfirmados -
            cadastro?.cadastrosNaoConfirmados.length
        )
      : 0;

  return (
    <Box className={styles.container}>
      {loading ? (
        <Loading loading={loading} />
      ) : (
        <Paper className={styles.paper}>
          <div className={styles.title}>
            <h1>
              <DirectionsCarIcon /> Vamos Vencer Juntos
            </h1>
            <Button variant="outlined" color="success" onClick={handleDownload}>
              <DownloadIcon sx={{ marginRight: ".5rem" }} /> Exportar
            </Button>
          </div>
          <div className={styles.card_qtd}>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Cadastros</h4>
              <p>{qtdCadastro?.qtdCadastros}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Acompanhantes</h4>
              <p>{qtdCadastro?.qtdAcompanhantes}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h3>Total</h3>
              <p>{qtdCadastro?.qtdTotal}</p>
            </div>
          </div>
          <div className={styles.card_qtd}>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Cadastros Fila</h4>
              <p>{qtdCadastro?.qtdFilaCadastros}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Acompanhantes Fila</h4>
              <p>{qtdCadastro?.qtdFilaAcompanhantes}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h3>Total Fila</h3>
              <p>{qtdCadastro?.qtdFilaTotal}</p>
            </div>
          </div>
          <div className={styles.card_qtd_sucesso}>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Confirmados</h4>
              <p>{qtdCadastro?.qtdConfirmadosCadastros}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Acompanhantes Confirmados</h4>
              <p>{qtdCadastro?.qtdConfirmadosAcompanhantes}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h3>Total Confirmados</h3>
              <p>{qtdCadastro?.qtdConfirmadosTotal}</p>
            </div>
          </div>
          <div className={styles.card_qtd_falha}>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Não Confirmados</h4>
              <p>{qtdCadastro?.qtdNaoConfirmadosCadastros}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h4>Qtd. Acompanhantes Não Confirmados</h4>
              <p>{qtdCadastro?.qtdNaoConfirmadosAcompanhantes}</p>
            </div>
            <div className={styles.card_qtd_item}>
              <h3>Total Não Confirmados</h3>
              <p>{qtdCadastro?.qtdNaoConfirmadosTotal}</p>
            </div>
          </div>
          <Box sx={{ width: "100%", marginTop: "2rem" }}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab label="Cadastrados" {...a11yProps(0)} />
                <Tab label="Fila de Espera" {...a11yProps(1)} />
                <Tab label="Confirmados" {...a11yProps(2)} />
                <Tab label="Não Confirmados" {...a11yProps(3)} />
              </Tabs>
            </Box>
            <CustomTabPanel value={value} index={0}>
              <TableContainer className={styles.card}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles.tableHeader} align="center">
                        Nome
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        WhatsApp
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        E-mail
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Empresa
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Qtd. Acompanhantes
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 1
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 2
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 3
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Data Cadastro
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPage > 0
                      ? cadastro?.cadastros?.slice(
                          page * rowsPerPage,
                          page * rowsPerPage + rowsPerPage
                        )
                      : cadastro?.cadastros
                    )?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell align="center">{item.nome}</TableCell>
                          <TableCell align="center">{item.whatsapp}</TableCell>
                          <TableCell align="center">{item.email}</TableCell>
                          <TableCell align="center">{item.empresa}</TableCell>
                          <TableCell align="center">
                            {item.qtdAcompanhante}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante1 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante2 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante3 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {handleCorrigeDate(item.dtCadastro) ?? "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={8} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={cadastro?.cadastros?.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={1}>
              <TableContainer className={styles.card}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles.tableHeader} align="center">
                        Nome
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        WhatsApp
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        E-mail
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Empresa
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Qtd. Acompanhantes
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 1
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 2
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 3
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Data Cadastro
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPageFila > 0
                      ? cadastro?.cadastrosFila?.slice(
                          pageFila * rowsPerPageFila,
                          pageFila * rowsPerPageFila + rowsPerPageFila
                        )
                      : cadastro?.cadastrosFila
                    )?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell align="center">{item.nome}</TableCell>
                          <TableCell align="center">{item.whatsapp}</TableCell>
                          <TableCell align="center">{item.email}</TableCell>
                          <TableCell align="center">{item.empresa}</TableCell>
                          <TableCell align="center">
                            {item.qtdAcompanhante}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante1 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante2 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante3 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {handleCorrigeDate(item.dtCadastro) ?? "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRowsFila > 0 && (
                      <TableRow style={{ height: 53 * emptyRowsFila }}>
                        <TableCell colSpan={8} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={cadastro?.cadastrosFila?.length}
                rowsPerPage={rowsPerPageFila}
                page={pageFila}
                onPageChange={handleChangePageFila}
                onRowsPerPageChange={handleChangeRowsPerPageFila}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={2}>
              <TableContainer className={styles.card}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles.tableHeader} align="center">
                        Nome
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        WhatsApp
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        E-mail
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Empresa
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Qtd. Acompanhantes
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 1
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 2
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 3
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Data Cadastro
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPageConfirmados > 0
                      ? cadastro?.cadastrosConfirmados?.slice(
                          pageConfirmados * rowsPerPageConfirmados,
                          pageConfirmados * rowsPerPageConfirmados +
                            rowsPerPageConfirmados
                        )
                      : cadastro?.cadastrosConfirmados
                    )?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell align="center">{item.nome}</TableCell>
                          <TableCell align="center">{item.whatsapp}</TableCell>
                          <TableCell align="center">{item.email}</TableCell>
                          <TableCell align="center">{item.empresa}</TableCell>
                          <TableCell align="center">
                            {item.qtdAcompanhante}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante1 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante2 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante3 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {handleCorrigeDate(item.dtCadastro) ?? "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRowsConfirmados > 0 && (
                      <TableRow style={{ height: 53 * emptyRowsConfirmados }}>
                        <TableCell colSpan={8} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={cadastro?.cadastrosConfirmados?.length}
                rowsPerPage={rowsPerPageConfirmados}
                page={pageConfirmados}
                onPageChange={handleChangePageConfirmados}
                onRowsPerPageChange={handleChangeRowsPerPageConfirmados}
              />
            </CustomTabPanel>
            <CustomTabPanel value={value} index={3}>
              <TableContainer className={styles.card}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell className={styles.tableHeader} align="center">
                        Nome
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        WhatsApp
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        E-mail
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Empresa
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Qtd. Acompanhantes
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 1
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 2
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Acompanhante 3
                      </TableCell>
                      <TableCell className={styles.tableHeader} align="center">
                        Data Cadastro
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {(rowsPerPageConfirmados > 0
                      ? cadastro?.cadastrosNaoConfirmados?.slice(
                          pageConfirmados * rowsPerPageConfirmados,
                          pageConfirmados * rowsPerPageConfirmados +
                            rowsPerPageConfirmados
                        )
                      : cadastro?.cadastrosNaoConfirmados
                    )?.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell align="center">{item.nome}</TableCell>
                          <TableCell align="center">{item.whatsapp}</TableCell>
                          <TableCell align="center">{item.email}</TableCell>
                          <TableCell align="center">{item.empresa}</TableCell>
                          <TableCell align="center">
                            {item.qtdAcompanhante}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante1 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante2 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {item.acompanhante3 ?? "-"}
                          </TableCell>
                          <TableCell align="center">
                            {handleCorrigeDate(item.dtCadastro) ?? "-"}
                          </TableCell>
                        </TableRow>
                      );
                    })}
                    {emptyRowsConfirmados > 0 && (
                      <TableRow style={{ height: 53 * emptyRowsConfirmados }}>
                        <TableCell colSpan={8} />
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                component="div"
                count={cadastro?.cadastrosNaoConfirmados?.length}
                rowsPerPage={rowsPerPageNaoConfirmados}
                page={pageNaoConfirmados}
                onPageChange={handleChangePageNaoConfirmados}
                onRowsPerPageChange={handleChangeRowsPerPageNaoConfirmados}
              />
            </CustomTabPanel>
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default VamosVencerJuntos;
